import { getUserDisplayName } from 'Utils/user';

import type { CourseModel } from '../data';

export const useCourseOrganizationDisplay = (course: CourseModel): string => {
  const trainerDisplayName = course.trainer?.displayName
    ? getUserDisplayName(course.trainer.displayName)
    : '';

  return course.organizationName && trainerDisplayName
    ? `${course.organizationName}, ${trainerDisplayName}`
    : (course.organizationName ?? trainerDisplayName ?? '');
};
